const ONBOARDING_VIDEO_DISMISSED_KEY = 'typix-onboarding-video-dismissed';

const getLocalAccessToken = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user?.accessTokenJwt;
};

const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

const removeUser = () => {
  localStorage.removeItem('user');
 
  localStorage.removeItem(ONBOARDING_VIDEO_DISMISSED_KEY);
};


const TokenService = {
  getLocalAccessToken,
  setUser, 
  removeUser, 
};

export default TokenService;
